// A mail folder travels through the url as an opaque id: the router decodes
// route params, and many places rebuild urls from that decoded value as plain
// strings. Characters the router would read as url syntax are therefore
// swapped for letter-only tokens instead of being percent-encoded:
// "%" breaks decoding, "?" starts the search and "#" starts the hash.
const TOKENS = {
  "%": "ypzrdcsngtn",
  "?": "qstnmrkzvbt",
  "#": "hshsgnzvbtq"
};

const CHARS = Object.fromEntries(
  Object.entries(TOKENS).map(([char, token]) => [token, char])
);

const TOKEN_REGEX = new RegExp(Object.values(TOKENS).join("|"), "g");

export const encodeFolderId = name =>
  String(name ?? "").replace(/[%?#]/g, char => TOKENS[char]);

export const decodeFolderId = folderId =>
  String(folderId ?? "").replace(TOKEN_REGEX, token => CHARS[token]);
